export default __webpack_public_path__ + "static/media/VFC_Jahresbericht_2022.8135b0a6.pdf";